<div class="parent-container">
  <div class="modal-header">
    <div class="row" style="width: 100%">
      <div class="col" style="width: 50%">
        <h4 class="modal-title">SET WORKSHOP HOURS</h4>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <div class="group-gap row mb-4">
        <app-schedulerSetHours [formData]="setWorkshopDayHourForm" [globalData]="globalData" (onFormGroupChange)="onChange($event)">
        </app-schedulerSetHours>
        <div class="col-md-3 mt-4">
          <div>
            <label class="resource-name-label">SELECT TIMEFRAME: </label>
          </div>
          <div *ngIf="hideDaysOptions">
            <div class="d-flex justify-content-start">
              <div style="color: green">&#9632;</div>
              Open
            </div>
            <div class="d-flex justify-content-start">
              <div style="color: red">&#9632;</div>
              Closed
            </div>
          </div>
        </div>

        <mat-radio-group aria-label="Select an option" class="col-md-8 mt-4">
          <div>
            <form [formGroup]="setWorkshopDayHourForm">
              <mat-radio-group aria-label="Select an option" class="col-md-8" formControlName="timeframe">
                <div class="col-md-4 mb-2">
                  <mat-radio-button [value]="1">JUST SPECIFIC DATES</mat-radio-button>
                  <div>
                    <div *ngIf="hideDaysOptions && setWorkshopDayHourForm.get('timeframe').value === 1" class="col-md-4 mb-2">
                      <div class="input-group">
                        <ngb-datepicker
                          #d2
                          [dayTemplate]="customDay"
                          (navigate)="navigateCalendar($event)"
                          [markDisabled]="isDisabled"
                        ></ngb-datepicker>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-2">
                  <label>RECURRING</label>
                </div>
                <div class="col-md-4 mb-2"><mat-radio-button [value]="2">ALL CURRENT AND FUTURE DATES</mat-radio-button></div>
                <div class="col-md-4"><mat-radio-button [value]="3">DATE RANGE</mat-radio-button></div>
                <div *ngIf="setWorkshopDayHourForm.get('timeframe').value !== 1" class="row">
                  <div class="col-md-4">
                    <label>FROM</label>
                  </div>
                  <div class="col-md-3">
                    <label>TO</label>
                  </div>
                  <div></div>
                  <div class="col-md-4">
                    <div class="input-group">
                      <input
                        class="form-control"
                        name="d1"
                        ngbDatepicker
                        #d1="ngbDatepicker"
                        [placement]="'bottom'"
                        container="body"
                        formControlName="recurringStartDate"
                        [readonly]="!timeframeEditable"
                      />
                      <div class="input-group-append">
                        <button class="btn btn-secondary calendar text-white btn-picker" (click)="d1.toggle()" type="button"></button>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="input-group">
                      <input
                        class="form-control"
                        name="d2"
                        ngbDatepicker
                        #d2="ngbDatepicker"
                        [placement]="'bottom'"
                        container="body"
                        formControlName="recurringEndDate"
                        [readonly]="!timeframeEditable"
                      />
                      <div class="input-group-append">
                        <button class="btn btn-secondary calendar text-white btn-picker" (click)="d2.toggle()" type="button"></button>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-radio-group>

              <div *ngIf="!hideDaysOptions" class="days-container">
                <div *ngFor="let day of daysOfWeek; let i = index" class="day-column">
                  <input type="checkbox" name="days" (click)="onCheckChange(day.name)" class="day-checkbox" />
                  <label>
                    <span class="btn m-1 bglightgrey btn-sm text-white" [style.backgroundColor]="getColorDayStatus(day.name)">{{ day.name }}</span>
                  </label>
                </div>
              </div>
            </form>
          </div>
        </mat-radio-group>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="col d-flex float-end justify-content-end">
      <button class="btn btn-cancel mx-1 px-2" (click)="submitWorkshopDayHourForm(false)">CANCEL</button>
      <button class="btn text-white mx-1 px-2" type="submit" [disabled]="!setWorkshopDayHourForm.valid || !isFormValid" (click)="submitForm()">
        SAVE
      </button>
    </div>
  </div>
</div>

<ng-template #customDay let-date="date" let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled">
  <div id="calanderDayParent{{ date.day }}{{ date.month }}{{ date.year }}" *ngIf="date.month === currentMonth" style="width:50px; margin-left:-10px">
    <div
      class="customCss"
      [class.hidden]="date.month !== currentMonth"
      id="calanderDayChild00{{ date.day }}{{ date.month }}{{ date.year }}"
      (click)="updateDate(date.day, date.month, date.year)"
    >
      {{ date.day }}
    </div>
    <div id="calanderValue{{ date.day }}{{ date.month }}{{ date.year }}" style="justify-content: center; font-size: x-small"></div>
  </div>
</ng-template>

<p-confirmDialog header="Warning" #sendMenuChangeConfirm key="sendMenuChangeConfirm">
  <p-footer>
    <button type="button" class="btn text-white" (click)="sendMenuChangeConfirm.onAccept()" style="width: 80px">SAVE</button>
    <button type="button" class="btn btn-cancel" (click)="sendMenuChangeConfirm.onReject()">NO</button>
  </p-footer>
</p-confirmDialog>
